export default __webpack_public_path__ + "static/media/artgallery-logo.a0e3d908.svg";